
import { Component, Vue, Prop, Watch } from "vue-property-decorator"
import FormField from "../../base_classes/FormField"
import { Formatting } from "../../util/formatting"
const dateFormat = new Formatting.DateFormatting()

@Component
export default class TimeField extends FormField {
    @Prop() label!: string
    @Prop() field!: string
    @Prop() errorRequired!: boolean
    @Prop() timeCleared?: Boolean

    show: boolean = false
    hours?: any
    originalTime!: string

    @Watch("show")
    onShow(show:boolean){
        if (show) this.originalTime = this.value[this.field]
        else this.hours = null
    }

    get computedTime() {
        var val: number =
            typeof this.value[this.field] === "string" ? parseInt(this.value[this.field]) : this.value[this.field]
        return val && dateFormat.time(new Date(val))
    }
    set computedTime(time: string) {
        if (time === null) return
        var split: string[] = time.split(":")
        var hrs = parseInt(split[0])
        var mins = parseInt(split[1])
        var date = new Date()
        date.setHours(hrs)
        date.setMinutes(mins)
        this.value[this.field] = date.getTime()
    }

    clickHour(h: any) {
        this.hours = h
    }

    clickMinute() {
        this.show = false
        if (this.errorRequired) this.$emit("clearErrorRequired", this.field)
        this.$emit("input", this.value)
        this.$emit("change", this.field)
    }

    clickClear(e: any) {
        console.log(e)
        e.preventDefault()
        this.value[this.field] = null
        this.$emit("input", this.value)
        this.$emit("change", this.field)
    }

    clickCancel(e: any) {
        this.value[this.field] = this.originalTime
        this.show = false
    }

    clickOk(e: any) {
        if (this.hours || this.hours === 0) {
            var date = new Date()
            date.setHours(this.hours)
            date.setMinutes(0)
            if (!this.value[this.field]) this.value[this.field] = date.getTime()
            this.clickMinute()
        } else {
            this.show = false
        }
    }
    setNow() {
        this.show = false
        this.computedTime = dateFormat.time(new Date())
        this.$emit("input", this.value)
        this.$emit("change", this.field)
    }

}
